export default class Login {
  public login? : string;
  public password? : string

}
